export default "__VITE_ASSET__CNJn1k0L__"